const manageCoursesPageStrings = {
  en: {
  pages: {
    create: "Create Slot",
    view: "View Slots",
    edit: "Edit Slots",
    delete: "Delete Slots",
  },

  // Create Slot Page Strings
  create: {
    title: "Create New Slot",
    description: "Add a new office hour slot to your schedule.",
    fields: {
      courseName: "Slot Name",
      section: "Section (Optional)",
      dayOfWeek: "Day of Week",
      room: "Room/Location",
      startTime: "Start Time",
      endTime: "End Time",
      duration: "Duration (minutes)",
      startDate: "Start Date",
      endDate: "End Date",
      studentLimit: "Student Limit per Slot (Optional)",
      csvFile: "Import Students (CSV)",
    },
    placeholders: {
      courseName: "e.g., CS 101 - Intro to Programming",
      section: "e.g., A1, B2",
      room: "e.g., Room 201",
      duration: "e.g., 60",
      studentLimit: "e.g., 1",
    },
    hints: {
      studentLimit: "Maximum number of students allowed per booking slot. Default is 1.",
    },
    csv: {
      label: "Import Students (CSV)",
      dragDrop: "Drag & drop a CSV file here, or click to browse",
      selectedFile: "Selected file:",
      removeFile: "Remove",
      hint: "CSV should contain columns: First name, Last name, ID number, Email address",
      optional: "Optional - You can add students later",
      uploading: "Uploading CSV...",
      uploadSuccess: "CSV uploaded successfully!",
      uploadError: "Failed to upload CSV.",
      studentsCreated: "students added",
      errors: "errors encountered",
    },
    dayOptions: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    buttons: {
      create: "Create Slot",
      creating: "Creating...",
    },
    success: "Slot created successfully!",
    errors: {
      courseNameRequired: "Slot name is required.",
      dayRequired: "Please select a day of week.",
      startTimeRequired: "Start time is required.",
      endTimeRequired: "End time is required.",
      startDateRequired: "Start date is required.",
      endDateRequired: "End date is required.",
      roomRequired: "Room/Location is required.",
      failed: "Failed to create slot. Please try again.",
    },
    recentSlots: "Recent Slots",
  },

  // View Slots Page Strings
  view: {
    title: "Your Slots",
    description: "View and manage all your office hour slots.",
    loading: "Loading your slots...",
    noSlots: "No Slots Yet",
    noSlotsDescription:
      "Use the Add Slot button to start building your schedule.",
    slotsFound: "slots found",
    sortBy: "Sort By",
    search: "Search",
    searchPlaceholder: "Search by slot name, section, or room",
    statusFilter: "Status",
    statusOptions: {
      all: "All",
      active: "Active",
      inactive: "Inactive",
    },
    sortOptions: {
      courseName: "Slot Name",
      dayOfWeek: "Day of Week",
      startTime: "Start Time",
    },
    section: "Section",
    day: "Day",
    time: "Time",
    room: "Room",
    studentLimit: "Student Limit",
    dates: "Dates",
    id: "ID",
    duration: "Duration (minutes)",
    createdAt: "Created At",
    actions: "Actions",
    listTitle: "Slot List",
    manageStudentsComingSoon: "Student management is coming soon.",
  
    to: "to",
    backToList: "Back to list",
    active: "Active",
    inactive: "Inactive",
    refresh: "Refresh",
    buttons: {
      edit: "Edit",
      delete: "Delete",
      activate: "Activate",
      deactivate: "Deactivate",
      toggling: "Toggling...",
      manageStudents: "Manage Allowed Students",
      addCourse: "Add Slot",
      saving: "Saving...",
      share: "Share",
      export: "Export CSV",
      exporting: "Exporting...",
    },
    export: {
      success: "Time slots exported successfully",
      error: "Failed to export time slots",
    },
  },

  // Edit Slots Page Strings
  edit: {
    title: "Edit Slot",
    description: "Modify the details of your office hour slot.",
    selectASlot: "Select a Slot to Edit",
    selectDescription:
      "Choose a slot from the View Slots tab or select one below.",
    availableSlots: "Available Slots:",
    editing: "Currently Editing",
    deselectSlot: "Deselect",
    fields: {
      courseName: "Course Name",
      section: "Section (Optional)",
      dayOfWeek: "Day of Week",
      room: "Room/Location",
      startTime: "Start Time",
      endTime: "End Time",
      duration: "Duration (minutes)",
      startDate: "Start Date",
      endDate: "End Date",
      studentLimit: "Student Limit per Slot (Optional)",
    },
    placeholders: {
      duration: "e.g., 60",
      studentLimit: "e.g., 1",
    },
    hints: {
      studentLimit: "Maximum number of students allowed per booking slot.",
    },
    dayOptions: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    buttons: {
      update: "Update Slot",
      updating: "Updating...",
    },
    success: "Slot updated successfully!",
    errors: {
      noSlotSelected: "Please select a slot to edit.",
      courseNameRequired: "Slot name is required.",
      dayRequired: "Please select a day of week.",
      startTimeRequired: "Start time is required.",
      endTimeRequired: "End time is required.",
      startDateRequired: "Start date is required.",
      endDateRequired: "End date is required.",
      roomRequired: "Room/Location is required.",
      failed: "Failed to update slot. Please try again.",
    },
  },

  // Delete Slots Page Strings
  delete: {
    title: "Delete Slot",
    description: "Permanently remove a slot from your schedule.",
    selectASlot: "Select a Slot to Delete",
    selectDescription:
      "Choose a slot from the View Slots tab or select one below.",
    availableSlots: "Available Slots:",
    deselectSlot: "Deselect",
    confirmMessage: "Are you sure? This action cannot be undone.",
    warning: {
      title: "⚠️ Warning",
      message:
        "Deleting this slot will remove all associated information. Students with bookings will be notified.",
    },
    details: {
      section: "Section",
      day: "Day",
      time: "Time",
      room: "Room",
      dates: "Dates",
      to: "to",
    },
    buttons: {
      delete: "Delete Slot",
      confirmDelete: "Confirm Delete",
      deleting: "Deleting...",
      cancel: "Cancel",
    },
    success: "Slot deleted successfully!",
    errors: {
      noSlotSelected: "Please select a slot to delete.",
      failed: "Failed to delete slot. Please try again.",
    },
  },
  modals: {
    createTitle: "Create New Slot",
    editTitle: "Edit Slot",
    deleteTitle: "Delete Slot",
    manageStudentsTitle: "Manage Allowed Students",
    shareTitle: "Share Office Hour Slot",
    comingSoon: "This feature is coming soon.",
    close: "Close",
  },

  // Share Slot Strings
  share: {
    slotInfo: "Slot Information",
    shareLink: "Share Link",
    copyLink: "Copy Link",
    copiedToClipboard: "Copied!",
    linkCopiedMessage: "Link copied to clipboard!",
    copyError: "Failed to copy link. Please try again.",
    instructions: "How to share:",
    instruction1: "Copy the link above",
    instruction2: "Share it with students via email, messaging, or any platform",
    instruction3: "Students can click the link to book this office hour slot",
    errorNoTAId: "Error: Unable to determine TA ID",
  },

  // Warning Modal Strings
  warningModal: {
    editTitle: "Confirm Slot Edit",
    editMessage: "Editing this slot may affect existing student bookings. Changes to date, time, or duration may cancel related bookings.",
    editWarning: "This action might cancel some student bookings and could take a moment to process.",
    editConfirm: "Continue Editing",
    editCancel: "Cancel",

    deactivateTitle: "Confirm Slot Deactivation",
    deactivateMessage: "Deactivating this slot will cancel all active student bookings.",
    deactivateWarning: "All students with bookings will be notified about the cancellation. This process might take a while.",
    deactivateConfirm: "Deactivate Slot",
    deactivateCancel: "Cancel",

    activateMessage: "Activating this slot will make it available for new bookings.",
    activateWarning: "Make sure the slot details are correct before activating.",
    activateConfirm: "Activate Slot",
  },
},
ar: {
  pages: {
    create: "إنشاء موعد",
    view: "عرض المواعيد",
    edit: "تعديل المواعيد",
    delete: "حذف المواعيد",
  },
  create: {
    title: "إنشاء موعد جديد",
    description: "أضف موعد ساعة مكتبية جديد إلى جدولك.",
    fields: {
      courseName: "اسم الموعد",
      section: "القسم (اختياري)",
      dayOfWeek: "يوم الأسبوع",
      room: "الغرفة/الموقع",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      duration: "المدة (بالدقائق)",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      studentLimit: "حد الطلاب لكل موعد (اختياري)",
      csvFile: "استيراد الطلاب (CSV)",
    },
    placeholders: {
      courseName: "مثال: CS 101 - مقدمة في البرمجة",
      section: "مثال: A1, B2",
      room: "مثال: غرفة 201",
      duration: "مثال: 60",
      studentLimit: "مثال: 1",
    },
    hints: {
      studentLimit: "الحد الأقصى لعدد الطلاب المسموح به لكل موعد حجز. الافتراضي هو 1.",
    },
    csv: {
      label: "استيراد الطلاب (CSV)",
      dragDrop: "اسحب وأفلت ملف CSV هنا، أو انقر للتصفح",
      selectedFile: "الملف المحدد:",
      removeFile: "إزالة",
      hint: "يجب أن يحتوي CSV على أعمدة: الاسم الأول، اسم العائلة، رقم الهوية، عنوان البريد الإلكتروني",
      optional: "اختياري - يمكنك إضافة الطلاب لاحقاً",
      uploading: "جارٍ رفع CSV...",
      uploadSuccess: "تم رفع CSV بنجاح!",
      uploadError: "فشل رفع CSV.",
      studentsCreated: "طالب مضاف",
      errors: "أخطاء واجهت",
    },
    dayOptions: ["الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
    buttons: {
      create: "إنشاء موعد",
      creating: "جارٍ الإنشاء...",
    },
    success: "تم إنشاء الموعد بنجاح!",
    errors: {
      courseNameRequired: "اسم الموعد مطلوب.",
      dayRequired: "يرجى اختيار يوم من أيام الأسبوع.",
      startTimeRequired: "وقت البدء مطلوب.",
      endTimeRequired: "وقت الانتهاء مطلوب.",
      startDateRequired: "تاريخ البدء مطلوب.",
      endDateRequired: "تاريخ الانتهاء مطلوب.",
      roomRequired: "الغرفة/الموقع مطلوب.",
      failed: "فشل إنشاء الموعد. يرجى المحاولة مرة أخرى.",
    },
    recentSlots: "المواعيد الأخيرة",
  },
  view: {
    title: "مواعيدك",
    description: "عرض وإدارة جميع مواعيد ساعاتك المكتبية.",
    loading: "جارٍ تحميل مواعيدك...",
    noSlots: "لا توجد مواعيد بعد",
    noSlotsDescription: "استخدم زر إضافة موعد لبدء بناء جدولك.",
    slotsFound: "موعد موجود",
    sortBy: "ترتيب حسب",
    search: "بحث",
    searchPlaceholder: "البحث باسم الموعد أو القسم أو الغرفة",
    statusFilter: "الحالة",
    statusOptions: {
      all: "الكل",
      active: "نشط",
      inactive: "غير نشط",
    },
    sortOptions: {
      courseName: "اسم الموعد",
      dayOfWeek: "يوم الأسبوع",
      startTime: "وقت البدء",
    },
    section: "القسم",
    day: "اليوم",
    time: "الوقت",
    room: "الغرفة",
    studentLimit: "حد الطلاب",
    dates: "التواريخ",
    id: "المعرف",
    duration: "المدة (بالدقائق)",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    listTitle: "قائمة المواعيد",
    manageStudentsComingSoon: "إدارة الطلاب قريباً.",
    to: "إلى",
    backToList: "العودة للقائمة",
    active: "نشط",
    inactive: "غير نشط",
    refresh: "تحديث",
    buttons: {
      edit: "تعديل",
      delete: "حذف",
      activate: "تفعيل",
      deactivate: "إلغاء التفعيل",
      toggling: "جارٍ التبديل...",
      manageStudents: "إدارة الطلاب المسموح لهم",
      addCourse: "إضافة موعد",
      saving: "جارٍ الحفظ...",
      share: "مشاركة",
      export: "تصدير CSV",
      exporting: "جارٍ التصدير...",
    },
    export: {
      success: "تم تصدير المواعيد بنجاح",
      error: "فشل تصدير المواعيد",
    },
  },
  edit: {
    title: "تعديل موعد",
    description: "تعديل تفاصيل موعد ساعتك المكتبية.",
    selectASlot: "اختر موعداً للتعديل",
    selectDescription: "اختر موعداً من علامة تبويب عرض المواعيد أو اختر واحداً أدناه.",
    availableSlots: "المواعيد المتاحة:",
    editing: "قيد التعديل حالياً",
    deselectSlot: "إلغاء التحديد",
    fields: {
      courseName: "اسم المقرر",
      section: "القسم (اختياري)",
      dayOfWeek: "يوم الأسبوع",
      room: "الغرفة/الموقع",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      duration: "المدة (بالدقائق)",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      studentLimit: "حد الطلاب لكل موعد (اختياري)",
    },
    placeholders: {
      duration: "مثال: 60",
      studentLimit: "مثال: 1",
    },
    hints: {
      studentLimit: "الحد الأقصى لعدد الطلاب المسموح به لكل موعد حجز.",
    },
    dayOptions: ["الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
    buttons: {
      update: "تحديث الموعد",
      updating: "جارٍ التحديث...",
    },
    success: "تم تحديث الموعد بنجاح!",
    errors: {
      noSlotSelected: "يرجى اختيار موعد للتعديل.",
      courseNameRequired: "اسم الموعد مطلوب.",
      dayRequired: "يرجى اختيار يوم من أيام الأسبوع.",
      startTimeRequired: "وقت البدء مطلوب.",
      endTimeRequired: "وقت الانتهاء مطلوب.",
      startDateRequired: "تاريخ البدء مطلوب.",
      endDateRequired: "تاريخ الانتهاء مطلوب.",
      roomRequired: "الغرفة/الموقع مطلوب.",
      failed: "فشل تحديث الموعد. يرجى المحاولة مرة أخرى.",
    },
  },
  delete: {
    title: "حذف موعد",
    description: "إزالة موعد نهائياً من جدولك.",
    selectASlot: "اختر موعداً للحذف",
    selectDescription: "اختر موعداً من علامة تبويب عرض المواعيد أو اختر واحداً أدناه.",
    availableSlots: "المواعيد المتاحة:",
    deselectSlot: "إلغاء التحديد",
    confirmMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
    warning: {
      title: "⚠️ تحذير",
      message: "حذف هذا الموعد سيزيل جميع المعلومات المرتبطة به. سيتم إشعار الطلاب الذين لديهم حجوزات.",
    },
    details: {
      section: "القسم",
      day: "اليوم",
      time: "الوقت",
      room: "الغرفة",
      dates: "التواريخ",
      to: "إلى",
    },
    buttons: {
      delete: "حذف الموعد",
      confirmDelete: "تأكيد الحذف",
      deleting: "جارٍ الحذف...",
      cancel: "إلغاء",
    },
    success: "تم حذف الموعد بنجاح!",
    errors: {
      noSlotSelected: "يرجى اختيار موعد للحذف.",
      failed: "فشل حذف الموعد. يرجى المحاولة مرة أخرى.",
    },
  },
  modals: {
    createTitle: "إنشاء موعد جديد",
    editTitle: "تعديل موعد",
    deleteTitle: "حذف موعد",
    manageStudentsTitle: "إدارة الطلاب المسموح لهم",
    shareTitle: "مشاركة موعد الساعة المكتبية",
    comingSoon: "هذه الميزة قادمة قريباً.",
    close: "إغلاق",
  },
  share: {
    slotInfo: "معلومات الموعد",
    shareLink: "رابط المشاركة",
    copyLink: "نسخ الرابط",
    copiedToClipboard: "تم النسخ!",
    linkCopiedMessage: "تم نسخ الرابط إلى الحافظة!",
    copyError: "فشل نسخ الرابط. يرجى المحاولة مرة أخرى.",
    instructions: "كيفية المشاركة:",
    instruction1: "انسخ الرابط أعلاه",
    instruction2: "شاركه مع الطلاب عبر البريد الإلكتروني أو الرسائل أو أي منصة",
    instruction3: "يمكن للطلاب النقر على الرابط لحجز هذا الموعد",
    errorNoTAId: "خطأ: تعذر تحديد معرف المعيد",
  },
  warningModal: {
    editTitle: "تأكيد تعديل الموعد",
    editMessage: "تعديل هذا الموعد قد يؤثر على حجوزات الطلاب الحالية. التغييرات في التاريخ أو الوقت أو المدة قد تلغي الحجوزات المرتبطة.",
    editWarning: "قد يؤدي هذا الإجراء إلى إلغاء بعض حجوزات الطلاب وقد يستغرق بعض الوقت للمعالجة.",
    editConfirm: "متابعة التعديل",
    editCancel: "إلغاء",
    deactivateTitle: "تأكيد إلغاء تفعيل الموعد",
    deactivateMessage: "إلغاء تفعيل هذا الموعد سيلغي جميع حجوزات الطلاب النشطة.",
    deactivateWarning: "سيتم إشعار جميع الطلاب الذين لديهم حجوزات بالإلغاء. قد تستغرق هذه العملية بعض الوقت.",
    deactivateConfirm: "إلغاء تفعيل الموعد",
    deactivateCancel: "إلغاء",
    activateMessage: "تفعيل هذا الموعد سيجعله متاحاً للحجوزات الجديدة.",
    activateWarning: "تأكد من صحة تفاصيل الموعد قبل التفعيل.",
    activateConfirm: "تفعيل الموعد",
  },
}
};

export default manageCoursesPageStrings;
